export default __webpack_public_path__ + "static/media/drum_line_icon.19ef3ecc.png";